module.exports = __webpack_public_path__ + "files/5e3bb097d78e0aabaccb44c7f14c3bbd.png";